/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedSelectClinicRouteImport } from './routes/_authed/select-clinic'
import { Route as AuthActionRouteImport } from './routes/auth/action'
import { Route as AuthedClinicsClinicIdRouteImport } from './routes/_authed/clinics/$clinicId'
import { Route as AuthedClinicsClinicIdAppointmentsRouteImport } from './routes/_authed/clinics/$clinicId/appointments'
import { Route as AuthedClinicsClinicIdErrorsRouteImport } from './routes/_authed/clinics/$clinicId/errors'
import { Route as AuthedClinicsClinicIdLinkRouteImport } from './routes/_authed/clinics/$clinicId/link'
import { Route as AuthedClinicsClinicIdSettingsRouteImport } from './routes/_authed/clinics/$clinicId/settings'
import { Route as AuthedClinicsClinicIdStatusRouteImport } from './routes/_authed/clinics/$clinicId/status'
import { Route as AuthedClinicsClinicIdUsersRouteImport } from './routes/_authed/clinics/$clinicId/users'
import { Route as AuthedClinicsClinicIdSettingsIndexRouteImport } from './routes/_authed/clinics/$clinicId/settings/index'
import { Route as AuthedClinicsClinicIdSettingsNotificationsRouteImport } from './routes/_authed/clinics/$clinicId/settings/notifications'
import { Route as AuthedClinicsClinicIdSettingsProfileRouteImport } from './routes/_authed/clinics/$clinicId/settings/profile'
import { Route as AuthedClinicsClinicIdSettingsSourcesRouteImport } from './routes/_authed/clinics/$clinicId/settings/sources'
import { Route as AuthedClinicsClinicIdSettingsBookingIndexRouteImport } from './routes/_authed/clinics/$clinicId/settings/booking/index'
import { Route as AuthedClinicsClinicIdSettingsBookingLocationsRouteImport } from './routes/_authed/clinics/$clinicId/settings/booking/locations'
import { Route as AuthedClinicsClinicIdSettingsBookingMapRouteImport } from './routes/_authed/clinics/$clinicId/settings/booking/map'
import { Route as AuthedClinicsClinicIdSettingsBookingProvidersRouteImport } from './routes/_authed/clinics/$clinicId/settings/booking/providers'
import { Route as AuthedClinicsClinicIdSettingsBookingRulesRouteImport } from './routes/_authed/clinics/$clinicId/settings/booking/rules'
import { Route as AuthedClinicsClinicIdSettingsBookingVisitTypesRouteImport } from './routes/_authed/clinics/$clinicId/settings/booking/visit-types'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSelectClinicRoute = AuthedSelectClinicRouteImport.update({
  id: '/select-clinic',
  path: '/select-clinic',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthActionRoute = AuthActionRouteImport.update({
  id: '/auth/action',
  path: '/auth/action',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedClinicsClinicIdRoute = AuthedClinicsClinicIdRouteImport.update({
  id: '/clinics/$clinicId',
  path: '/clinics/$clinicId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClinicsClinicIdAppointmentsRoute =
  AuthedClinicsClinicIdAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthedClinicsClinicIdRoute,
  } as any)
const AuthedClinicsClinicIdErrorsRoute =
  AuthedClinicsClinicIdErrorsRouteImport.update({
    id: '/errors',
    path: '/errors',
    getParentRoute: () => AuthedClinicsClinicIdRoute,
  } as any)
const AuthedClinicsClinicIdLinkRoute =
  AuthedClinicsClinicIdLinkRouteImport.update({
    id: '/link',
    path: '/link',
    getParentRoute: () => AuthedClinicsClinicIdRoute,
  } as any)
const AuthedClinicsClinicIdSettingsRoute =
  AuthedClinicsClinicIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedClinicsClinicIdRoute,
  } as any)
const AuthedClinicsClinicIdStatusRoute =
  AuthedClinicsClinicIdStatusRouteImport.update({
    id: '/status',
    path: '/status',
    getParentRoute: () => AuthedClinicsClinicIdRoute,
  } as any)
const AuthedClinicsClinicIdUsersRoute =
  AuthedClinicsClinicIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthedClinicsClinicIdRoute,
  } as any)
const AuthedClinicsClinicIdSettingsIndexRoute =
  AuthedClinicsClinicIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedClinicsClinicIdSettingsRoute,
  } as any)
const AuthedClinicsClinicIdSettingsNotificationsRoute =
  AuthedClinicsClinicIdSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthedClinicsClinicIdSettingsRoute,
  } as any)
const AuthedClinicsClinicIdSettingsProfileRoute =
  AuthedClinicsClinicIdSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthedClinicsClinicIdSettingsRoute,
  } as any)
const AuthedClinicsClinicIdSettingsSourcesRoute =
  AuthedClinicsClinicIdSettingsSourcesRouteImport.update({
    id: '/sources',
    path: '/sources',
    getParentRoute: () => AuthedClinicsClinicIdSettingsRoute,
  } as any)
const AuthedClinicsClinicIdSettingsBookingIndexRoute =
  AuthedClinicsClinicIdSettingsBookingIndexRouteImport.update({
    id: '/booking/',
    path: '/booking/',
    getParentRoute: () => AuthedClinicsClinicIdSettingsRoute,
  } as any)
const AuthedClinicsClinicIdSettingsBookingLocationsRoute =
  AuthedClinicsClinicIdSettingsBookingLocationsRouteImport.update({
    id: '/booking/locations',
    path: '/booking/locations',
    getParentRoute: () => AuthedClinicsClinicIdSettingsRoute,
  } as any)
const AuthedClinicsClinicIdSettingsBookingMapRoute =
  AuthedClinicsClinicIdSettingsBookingMapRouteImport.update({
    id: '/booking/map',
    path: '/booking/map',
    getParentRoute: () => AuthedClinicsClinicIdSettingsRoute,
  } as any)
const AuthedClinicsClinicIdSettingsBookingProvidersRoute =
  AuthedClinicsClinicIdSettingsBookingProvidersRouteImport.update({
    id: '/booking/providers',
    path: '/booking/providers',
    getParentRoute: () => AuthedClinicsClinicIdSettingsRoute,
  } as any)
const AuthedClinicsClinicIdSettingsBookingRulesRoute =
  AuthedClinicsClinicIdSettingsBookingRulesRouteImport.update({
    id: '/booking/rules',
    path: '/booking/rules',
    getParentRoute: () => AuthedClinicsClinicIdSettingsRoute,
  } as any)
const AuthedClinicsClinicIdSettingsBookingVisitTypesRoute =
  AuthedClinicsClinicIdSettingsBookingVisitTypesRouteImport.update({
    id: '/booking/visit-types',
    path: '/booking/visit-types',
    getParentRoute: () => AuthedClinicsClinicIdSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/impersonate': typeof ImpersonateRoute
  '/no-access': typeof NoAccessRoute
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/select-clinic': typeof AuthedSelectClinicRoute
  '/auth/action': typeof AuthActionRoute
  '/clinics/$clinicId': typeof AuthedClinicsClinicIdRouteWithChildren
  '/clinics/$clinicId/appointments': typeof AuthedClinicsClinicIdAppointmentsRoute
  '/clinics/$clinicId/errors': typeof AuthedClinicsClinicIdErrorsRoute
  '/clinics/$clinicId/link': typeof AuthedClinicsClinicIdLinkRoute
  '/clinics/$clinicId/settings': typeof AuthedClinicsClinicIdSettingsRouteWithChildren
  '/clinics/$clinicId/status': typeof AuthedClinicsClinicIdStatusRoute
  '/clinics/$clinicId/users': typeof AuthedClinicsClinicIdUsersRoute
  '/clinics/$clinicId/settings/notifications': typeof AuthedClinicsClinicIdSettingsNotificationsRoute
  '/clinics/$clinicId/settings/profile': typeof AuthedClinicsClinicIdSettingsProfileRoute
  '/clinics/$clinicId/settings/sources': typeof AuthedClinicsClinicIdSettingsSourcesRoute
  '/clinics/$clinicId/settings/': typeof AuthedClinicsClinicIdSettingsIndexRoute
  '/clinics/$clinicId/settings/booking/locations': typeof AuthedClinicsClinicIdSettingsBookingLocationsRoute
  '/clinics/$clinicId/settings/booking/map': typeof AuthedClinicsClinicIdSettingsBookingMapRoute
  '/clinics/$clinicId/settings/booking/providers': typeof AuthedClinicsClinicIdSettingsBookingProvidersRoute
  '/clinics/$clinicId/settings/booking/rules': typeof AuthedClinicsClinicIdSettingsBookingRulesRoute
  '/clinics/$clinicId/settings/booking/visit-types': typeof AuthedClinicsClinicIdSettingsBookingVisitTypesRoute
  '/clinics/$clinicId/settings/booking/': typeof AuthedClinicsClinicIdSettingsBookingIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/impersonate': typeof ImpersonateRoute
  '/no-access': typeof NoAccessRoute
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/select-clinic': typeof AuthedSelectClinicRoute
  '/auth/action': typeof AuthActionRoute
  '/': typeof AuthedIndexRoute
  '/clinics/$clinicId': typeof AuthedClinicsClinicIdRouteWithChildren
  '/clinics/$clinicId/appointments': typeof AuthedClinicsClinicIdAppointmentsRoute
  '/clinics/$clinicId/errors': typeof AuthedClinicsClinicIdErrorsRoute
  '/clinics/$clinicId/link': typeof AuthedClinicsClinicIdLinkRoute
  '/clinics/$clinicId/status': typeof AuthedClinicsClinicIdStatusRoute
  '/clinics/$clinicId/users': typeof AuthedClinicsClinicIdUsersRoute
  '/clinics/$clinicId/settings/notifications': typeof AuthedClinicsClinicIdSettingsNotificationsRoute
  '/clinics/$clinicId/settings/profile': typeof AuthedClinicsClinicIdSettingsProfileRoute
  '/clinics/$clinicId/settings/sources': typeof AuthedClinicsClinicIdSettingsSourcesRoute
  '/clinics/$clinicId/settings': typeof AuthedClinicsClinicIdSettingsIndexRoute
  '/clinics/$clinicId/settings/booking/locations': typeof AuthedClinicsClinicIdSettingsBookingLocationsRoute
  '/clinics/$clinicId/settings/booking/map': typeof AuthedClinicsClinicIdSettingsBookingMapRoute
  '/clinics/$clinicId/settings/booking/providers': typeof AuthedClinicsClinicIdSettingsBookingProvidersRoute
  '/clinics/$clinicId/settings/booking/rules': typeof AuthedClinicsClinicIdSettingsBookingRulesRoute
  '/clinics/$clinicId/settings/booking/visit-types': typeof AuthedClinicsClinicIdSettingsBookingVisitTypesRoute
  '/clinics/$clinicId/settings/booking': typeof AuthedClinicsClinicIdSettingsBookingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/impersonate': typeof ImpersonateRoute
  '/no-access': typeof NoAccessRoute
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/_authed/select-clinic': typeof AuthedSelectClinicRoute
  '/auth/action': typeof AuthActionRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/clinics/$clinicId': typeof AuthedClinicsClinicIdRouteWithChildren
  '/_authed/clinics/$clinicId/appointments': typeof AuthedClinicsClinicIdAppointmentsRoute
  '/_authed/clinics/$clinicId/errors': typeof AuthedClinicsClinicIdErrorsRoute
  '/_authed/clinics/$clinicId/link': typeof AuthedClinicsClinicIdLinkRoute
  '/_authed/clinics/$clinicId/settings': typeof AuthedClinicsClinicIdSettingsRouteWithChildren
  '/_authed/clinics/$clinicId/status': typeof AuthedClinicsClinicIdStatusRoute
  '/_authed/clinics/$clinicId/users': typeof AuthedClinicsClinicIdUsersRoute
  '/_authed/clinics/$clinicId/settings/notifications': typeof AuthedClinicsClinicIdSettingsNotificationsRoute
  '/_authed/clinics/$clinicId/settings/profile': typeof AuthedClinicsClinicIdSettingsProfileRoute
  '/_authed/clinics/$clinicId/settings/sources': typeof AuthedClinicsClinicIdSettingsSourcesRoute
  '/_authed/clinics/$clinicId/settings/': typeof AuthedClinicsClinicIdSettingsIndexRoute
  '/_authed/clinics/$clinicId/settings/booking/locations': typeof AuthedClinicsClinicIdSettingsBookingLocationsRoute
  '/_authed/clinics/$clinicId/settings/booking/map': typeof AuthedClinicsClinicIdSettingsBookingMapRoute
  '/_authed/clinics/$clinicId/settings/booking/providers': typeof AuthedClinicsClinicIdSettingsBookingProvidersRoute
  '/_authed/clinics/$clinicId/settings/booking/rules': typeof AuthedClinicsClinicIdSettingsBookingRulesRoute
  '/_authed/clinics/$clinicId/settings/booking/visit-types': typeof AuthedClinicsClinicIdSettingsBookingVisitTypesRoute
  '/_authed/clinics/$clinicId/settings/booking/': typeof AuthedClinicsClinicIdSettingsBookingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/impersonate'
    | '/no-access'
    | '/set-password'
    | '/sign-in'
    | '/select-clinic'
    | '/auth/action'
    | '/clinics/$clinicId'
    | '/clinics/$clinicId/appointments'
    | '/clinics/$clinicId/errors'
    | '/clinics/$clinicId/link'
    | '/clinics/$clinicId/settings'
    | '/clinics/$clinicId/status'
    | '/clinics/$clinicId/users'
    | '/clinics/$clinicId/settings/notifications'
    | '/clinics/$clinicId/settings/profile'
    | '/clinics/$clinicId/settings/sources'
    | '/clinics/$clinicId/settings/'
    | '/clinics/$clinicId/settings/booking/locations'
    | '/clinics/$clinicId/settings/booking/map'
    | '/clinics/$clinicId/settings/booking/providers'
    | '/clinics/$clinicId/settings/booking/rules'
    | '/clinics/$clinicId/settings/booking/visit-types'
    | '/clinics/$clinicId/settings/booking/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/impersonate'
    | '/no-access'
    | '/set-password'
    | '/sign-in'
    | '/select-clinic'
    | '/auth/action'
    | '/'
    | '/clinics/$clinicId'
    | '/clinics/$clinicId/appointments'
    | '/clinics/$clinicId/errors'
    | '/clinics/$clinicId/link'
    | '/clinics/$clinicId/status'
    | '/clinics/$clinicId/users'
    | '/clinics/$clinicId/settings/notifications'
    | '/clinics/$clinicId/settings/profile'
    | '/clinics/$clinicId/settings/sources'
    | '/clinics/$clinicId/settings'
    | '/clinics/$clinicId/settings/booking/locations'
    | '/clinics/$clinicId/settings/booking/map'
    | '/clinics/$clinicId/settings/booking/providers'
    | '/clinics/$clinicId/settings/booking/rules'
    | '/clinics/$clinicId/settings/booking/visit-types'
    | '/clinics/$clinicId/settings/booking'
  id:
    | '__root__'
    | '/_authed'
    | '/forgot-password'
    | '/impersonate'
    | '/no-access'
    | '/set-password'
    | '/sign-in'
    | '/_authed/select-clinic'
    | '/auth/action'
    | '/_authed/'
    | '/_authed/clinics/$clinicId'
    | '/_authed/clinics/$clinicId/appointments'
    | '/_authed/clinics/$clinicId/errors'
    | '/_authed/clinics/$clinicId/link'
    | '/_authed/clinics/$clinicId/settings'
    | '/_authed/clinics/$clinicId/status'
    | '/_authed/clinics/$clinicId/users'
    | '/_authed/clinics/$clinicId/settings/notifications'
    | '/_authed/clinics/$clinicId/settings/profile'
    | '/_authed/clinics/$clinicId/settings/sources'
    | '/_authed/clinics/$clinicId/settings/'
    | '/_authed/clinics/$clinicId/settings/booking/locations'
    | '/_authed/clinics/$clinicId/settings/booking/map'
    | '/_authed/clinics/$clinicId/settings/booking/providers'
    | '/_authed/clinics/$clinicId/settings/booking/rules'
    | '/_authed/clinics/$clinicId/settings/booking/visit-types'
    | '/_authed/clinics/$clinicId/settings/booking/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ImpersonateRoute: typeof ImpersonateRoute
  NoAccessRoute: typeof NoAccessRoute
  SetPasswordRoute: typeof SetPasswordRoute
  SignInRoute: typeof SignInRoute
  AuthActionRoute: typeof AuthActionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/select-clinic': {
      id: '/_authed/select-clinic'
      path: '/select-clinic'
      fullPath: '/select-clinic'
      preLoaderRoute: typeof AuthedSelectClinicRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/auth/action': {
      id: '/auth/action'
      path: '/auth/action'
      fullPath: '/auth/action'
      preLoaderRoute: typeof AuthActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/clinics/$clinicId': {
      id: '/_authed/clinics/$clinicId'
      path: '/clinics/$clinicId'
      fullPath: '/clinics/$clinicId'
      preLoaderRoute: typeof AuthedClinicsClinicIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clinics/$clinicId/appointments': {
      id: '/_authed/clinics/$clinicId/appointments'
      path: '/appointments'
      fullPath: '/clinics/$clinicId/appointments'
      preLoaderRoute: typeof AuthedClinicsClinicIdAppointmentsRouteImport
      parentRoute: typeof AuthedClinicsClinicIdRoute
    }
    '/_authed/clinics/$clinicId/errors': {
      id: '/_authed/clinics/$clinicId/errors'
      path: '/errors'
      fullPath: '/clinics/$clinicId/errors'
      preLoaderRoute: typeof AuthedClinicsClinicIdErrorsRouteImport
      parentRoute: typeof AuthedClinicsClinicIdRoute
    }
    '/_authed/clinics/$clinicId/link': {
      id: '/_authed/clinics/$clinicId/link'
      path: '/link'
      fullPath: '/clinics/$clinicId/link'
      preLoaderRoute: typeof AuthedClinicsClinicIdLinkRouteImport
      parentRoute: typeof AuthedClinicsClinicIdRoute
    }
    '/_authed/clinics/$clinicId/settings': {
      id: '/_authed/clinics/$clinicId/settings'
      path: '/settings'
      fullPath: '/clinics/$clinicId/settings'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsRouteImport
      parentRoute: typeof AuthedClinicsClinicIdRoute
    }
    '/_authed/clinics/$clinicId/status': {
      id: '/_authed/clinics/$clinicId/status'
      path: '/status'
      fullPath: '/clinics/$clinicId/status'
      preLoaderRoute: typeof AuthedClinicsClinicIdStatusRouteImport
      parentRoute: typeof AuthedClinicsClinicIdRoute
    }
    '/_authed/clinics/$clinicId/users': {
      id: '/_authed/clinics/$clinicId/users'
      path: '/users'
      fullPath: '/clinics/$clinicId/users'
      preLoaderRoute: typeof AuthedClinicsClinicIdUsersRouteImport
      parentRoute: typeof AuthedClinicsClinicIdRoute
    }
    '/_authed/clinics/$clinicId/settings/': {
      id: '/_authed/clinics/$clinicId/settings/'
      path: '/'
      fullPath: '/clinics/$clinicId/settings/'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsIndexRouteImport
      parentRoute: typeof AuthedClinicsClinicIdSettingsRoute
    }
    '/_authed/clinics/$clinicId/settings/notifications': {
      id: '/_authed/clinics/$clinicId/settings/notifications'
      path: '/notifications'
      fullPath: '/clinics/$clinicId/settings/notifications'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsNotificationsRouteImport
      parentRoute: typeof AuthedClinicsClinicIdSettingsRoute
    }
    '/_authed/clinics/$clinicId/settings/profile': {
      id: '/_authed/clinics/$clinicId/settings/profile'
      path: '/profile'
      fullPath: '/clinics/$clinicId/settings/profile'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsProfileRouteImport
      parentRoute: typeof AuthedClinicsClinicIdSettingsRoute
    }
    '/_authed/clinics/$clinicId/settings/sources': {
      id: '/_authed/clinics/$clinicId/settings/sources'
      path: '/sources'
      fullPath: '/clinics/$clinicId/settings/sources'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsSourcesRouteImport
      parentRoute: typeof AuthedClinicsClinicIdSettingsRoute
    }
    '/_authed/clinics/$clinicId/settings/booking/': {
      id: '/_authed/clinics/$clinicId/settings/booking/'
      path: '/booking'
      fullPath: '/clinics/$clinicId/settings/booking/'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsBookingIndexRouteImport
      parentRoute: typeof AuthedClinicsClinicIdSettingsRoute
    }
    '/_authed/clinics/$clinicId/settings/booking/locations': {
      id: '/_authed/clinics/$clinicId/settings/booking/locations'
      path: '/booking/locations'
      fullPath: '/clinics/$clinicId/settings/booking/locations'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsBookingLocationsRouteImport
      parentRoute: typeof AuthedClinicsClinicIdSettingsRoute
    }
    '/_authed/clinics/$clinicId/settings/booking/map': {
      id: '/_authed/clinics/$clinicId/settings/booking/map'
      path: '/booking/map'
      fullPath: '/clinics/$clinicId/settings/booking/map'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsBookingMapRouteImport
      parentRoute: typeof AuthedClinicsClinicIdSettingsRoute
    }
    '/_authed/clinics/$clinicId/settings/booking/providers': {
      id: '/_authed/clinics/$clinicId/settings/booking/providers'
      path: '/booking/providers'
      fullPath: '/clinics/$clinicId/settings/booking/providers'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsBookingProvidersRouteImport
      parentRoute: typeof AuthedClinicsClinicIdSettingsRoute
    }
    '/_authed/clinics/$clinicId/settings/booking/rules': {
      id: '/_authed/clinics/$clinicId/settings/booking/rules'
      path: '/booking/rules'
      fullPath: '/clinics/$clinicId/settings/booking/rules'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsBookingRulesRouteImport
      parentRoute: typeof AuthedClinicsClinicIdSettingsRoute
    }
    '/_authed/clinics/$clinicId/settings/booking/visit-types': {
      id: '/_authed/clinics/$clinicId/settings/booking/visit-types'
      path: '/booking/visit-types'
      fullPath: '/clinics/$clinicId/settings/booking/visit-types'
      preLoaderRoute: typeof AuthedClinicsClinicIdSettingsBookingVisitTypesRouteImport
      parentRoute: typeof AuthedClinicsClinicIdSettingsRoute
    }
  }
}

interface AuthedClinicsClinicIdSettingsRouteChildren {
  AuthedClinicsClinicIdSettingsNotificationsRoute: typeof AuthedClinicsClinicIdSettingsNotificationsRoute
  AuthedClinicsClinicIdSettingsProfileRoute: typeof AuthedClinicsClinicIdSettingsProfileRoute
  AuthedClinicsClinicIdSettingsSourcesRoute: typeof AuthedClinicsClinicIdSettingsSourcesRoute
  AuthedClinicsClinicIdSettingsIndexRoute: typeof AuthedClinicsClinicIdSettingsIndexRoute
  AuthedClinicsClinicIdSettingsBookingLocationsRoute: typeof AuthedClinicsClinicIdSettingsBookingLocationsRoute
  AuthedClinicsClinicIdSettingsBookingMapRoute: typeof AuthedClinicsClinicIdSettingsBookingMapRoute
  AuthedClinicsClinicIdSettingsBookingProvidersRoute: typeof AuthedClinicsClinicIdSettingsBookingProvidersRoute
  AuthedClinicsClinicIdSettingsBookingRulesRoute: typeof AuthedClinicsClinicIdSettingsBookingRulesRoute
  AuthedClinicsClinicIdSettingsBookingVisitTypesRoute: typeof AuthedClinicsClinicIdSettingsBookingVisitTypesRoute
  AuthedClinicsClinicIdSettingsBookingIndexRoute: typeof AuthedClinicsClinicIdSettingsBookingIndexRoute
}

const AuthedClinicsClinicIdSettingsRouteChildren: AuthedClinicsClinicIdSettingsRouteChildren =
  {
    AuthedClinicsClinicIdSettingsNotificationsRoute:
      AuthedClinicsClinicIdSettingsNotificationsRoute,
    AuthedClinicsClinicIdSettingsProfileRoute:
      AuthedClinicsClinicIdSettingsProfileRoute,
    AuthedClinicsClinicIdSettingsSourcesRoute:
      AuthedClinicsClinicIdSettingsSourcesRoute,
    AuthedClinicsClinicIdSettingsIndexRoute:
      AuthedClinicsClinicIdSettingsIndexRoute,
    AuthedClinicsClinicIdSettingsBookingLocationsRoute:
      AuthedClinicsClinicIdSettingsBookingLocationsRoute,
    AuthedClinicsClinicIdSettingsBookingMapRoute:
      AuthedClinicsClinicIdSettingsBookingMapRoute,
    AuthedClinicsClinicIdSettingsBookingProvidersRoute:
      AuthedClinicsClinicIdSettingsBookingProvidersRoute,
    AuthedClinicsClinicIdSettingsBookingRulesRoute:
      AuthedClinicsClinicIdSettingsBookingRulesRoute,
    AuthedClinicsClinicIdSettingsBookingVisitTypesRoute:
      AuthedClinicsClinicIdSettingsBookingVisitTypesRoute,
    AuthedClinicsClinicIdSettingsBookingIndexRoute:
      AuthedClinicsClinicIdSettingsBookingIndexRoute,
  }

const AuthedClinicsClinicIdSettingsRouteWithChildren =
  AuthedClinicsClinicIdSettingsRoute._addFileChildren(
    AuthedClinicsClinicIdSettingsRouteChildren,
  )

interface AuthedClinicsClinicIdRouteChildren {
  AuthedClinicsClinicIdAppointmentsRoute: typeof AuthedClinicsClinicIdAppointmentsRoute
  AuthedClinicsClinicIdErrorsRoute: typeof AuthedClinicsClinicIdErrorsRoute
  AuthedClinicsClinicIdLinkRoute: typeof AuthedClinicsClinicIdLinkRoute
  AuthedClinicsClinicIdSettingsRoute: typeof AuthedClinicsClinicIdSettingsRouteWithChildren
  AuthedClinicsClinicIdStatusRoute: typeof AuthedClinicsClinicIdStatusRoute
  AuthedClinicsClinicIdUsersRoute: typeof AuthedClinicsClinicIdUsersRoute
}

const AuthedClinicsClinicIdRouteChildren: AuthedClinicsClinicIdRouteChildren = {
  AuthedClinicsClinicIdAppointmentsRoute:
    AuthedClinicsClinicIdAppointmentsRoute,
  AuthedClinicsClinicIdErrorsRoute: AuthedClinicsClinicIdErrorsRoute,
  AuthedClinicsClinicIdLinkRoute: AuthedClinicsClinicIdLinkRoute,
  AuthedClinicsClinicIdSettingsRoute:
    AuthedClinicsClinicIdSettingsRouteWithChildren,
  AuthedClinicsClinicIdStatusRoute: AuthedClinicsClinicIdStatusRoute,
  AuthedClinicsClinicIdUsersRoute: AuthedClinicsClinicIdUsersRoute,
}

const AuthedClinicsClinicIdRouteWithChildren =
  AuthedClinicsClinicIdRoute._addFileChildren(
    AuthedClinicsClinicIdRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedSelectClinicRoute: typeof AuthedSelectClinicRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedClinicsClinicIdRoute: typeof AuthedClinicsClinicIdRouteWithChildren
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedSelectClinicRoute: AuthedSelectClinicRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedClinicsClinicIdRoute: AuthedClinicsClinicIdRouteWithChildren,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ImpersonateRoute: ImpersonateRoute,
  NoAccessRoute: NoAccessRoute,
  SetPasswordRoute: SetPasswordRoute,
  SignInRoute: SignInRoute,
  AuthActionRoute: AuthActionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
